/* esm.sh - applesauce-common@5.2.0/helpers/comment */
export * from "/*applesauce-common@5.2.0/esnext/helpers/comment.mjs";
